module.exports = __webpack_public_path__ + "img/tab_zhongnongwang_0.f222f23c.png";